<template>
  <div class="remind">
    <div class="title">
      <img src="../../../../assets/game/yz_gamebelieved_remind.png" alt="" />
    </div>
    <div class="change_info">
      <slot name="info"></slot>
    </div>

    <ul>
      <li>1. 游戏首笔充值后<span>2小时内</span>可申请</li>
      <li>2. 收回小号，退还2小时内总充值<span>赠送余额*50%</span></li>
      <li>3. 退还赠送余额至余额，最高可退<span>500赠送余额</span></li>
    </ul>
  </div>
</template>
<style scoped>
.remind .title img {
  width: 100%;
  margin-top: 64px;
  margin-bottom: 32px;
}
.remind ul {
  margin: 24px 32px;
  background-color: #fff;
  padding: 32px;
  font-size: 24px;
  border-radius: 24px;
  color: #333;
}
.remind ul li:nth-of-type(2) {
  margin: 24px 0;
}
.remind ul li span {
  color: #ff8000;
}
.change_info {
  margin: 0 64px;
  color: #333;
}
</style>
